import React, { useState } from 'react';
import { Address } from '../../../types/interfaces';
import { getTaxLabelForLegalEntity } from '@shared/lib/tax-label';

const thCls = "p-3 text-[#9b9fac] text-[14px] font-medium border-b border-[#e9edf2] text-left";
const tdCls = "p-3 font-medium text-[#242426] align-top border-b border-[#e9edf2]";

function AddressAccordion({ addresses }: { addresses: Address[] }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <button
        className="flex items-center justify-between w-full text-left py-1 px-2 rounded hover:bg-gray-50 transition-colors"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span>Показать адреса</span>
        <span className="ml-2">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className="mt-2 flex flex-col gap-3">
          {addresses.map((address: Address, addrIndex: number) => (
            <div key={addrIndex} className="text-sm text-gray-700">
              <p>{`Тип: ${address.type === 'legal' ? 'Юридический' : 'Физический'}`}</p>
              <p>{`Страна: ${address.country}`}</p>
              <p>{`Регион: ${address.region}`}</p>
              <p>{`Город: ${address.city}`}</p>
              <p>{`Улица: ${address.street}`}</p>
              <p>{`Дом: ${address.house}`}</p>
              <p>{`Квартира: ${address.apartment}`}</p>
              <p>{`Почтовый индекс: ${address.postcode}`}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const RegistrationTable = ({ legalEntities }: { legalEntities: any[] }) => {
  // Лейбл налогового номера колонки — общий хелпер, тот же что и на
  // других экранах. На этом шаге в массиве почти всегда одно юр.лицо.
  const headerTaxLabel = getTaxLabelForLegalEntity(legalEntities?.[0]);

  return (
    <table className="w-full rounded-md shadow-md overflow-hidden">
      <thead>
        <tr>
          <th className={thCls}>Название Юридического Лица</th>
          <th className={thCls}>Электронная почта</th>
          <th className={thCls}>Телефоны</th>
          <th className={thCls}>{headerTaxLabel}</th>
          <th className={thCls}>Адреса</th>
        </tr>
      </thead>
      <tbody>
        {legalEntities.map((legalEntity, index) => (
          <tr key={index} className="hover:bg-blue-50 transition-colors">
            <td className={tdCls}>{legalEntity.name}</td>
            <td className={tdCls}>{legalEntity.email}</td>
            <td className={tdCls}>{legalEntity.phones.join(', ')}</td>
            <td className={tdCls}>{legalEntity.inn}</td>
            <td className={tdCls}>
              <AddressAccordion addresses={legalEntity.addresses} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RegistrationTable;
